<template>
    <section class="plan-container">
        <header class="plan-top-panel">
            <div class="header-left">
                <a-space>
                    <arrow-left-outlined class="color-fff" @click="handleBack"/>
                    <a-button type="primary" @click="handleSave">保存</a-button>
                    <div class="name color-fff">{{ planDetail.name }}</div>
                </a-space>
            </div>
            <div class="header-right"></div>
        </header>
        <section class="plan-content">
            <aside class="plan-left-panel">
                <div class="plan-aside-childern">
                    <div class="plan-aside-top">
                        <a-space class="flex-space-between-center" style="display: flex">
                            <div class="plan-top-title">列表</div>
                            <a-button ghost @click="handleAddFolder">新建分组</a-button>
                        </a-space>
                    </div>
                    <div class="plan-aside-content"
                        @dragover.prevent
                        @drop="handleDropToMainEnd">
                        <div v-if="detailIconGroupList.length === 0 && !addFolder.visible" class="empty-box">
                            <a-empty />
                        </div>
                        <template v-else>
                            <div>
                            <div class="list-item" :key="item.id" :style="item.dataType === '1' ? '' : 'display:block'"
                                v-for="(item, index) in detailIconGroupList" draggable="true"
                                @click="handleSet(item)"
                                @dragstart="handleDragStart(item, index)"
                                @dragover="handleDragOverMain($event, item, index)" @dragend="handleDragEnd"
                                @drop="handleDropToMain($event, index, item)">
                                <template v-if="item.dataType === '1'">
                                    <div class="list-left">
                                        <div class="file-image">
                                            <img :src="item.downloadUrl" alt="file-image" class="file-image-icon"
                                                width="20" height="20" />
                                        </div>
                                        <div class="list-meta">
                                            <div class="list-title">{{ item.iconName }}</div>
                                        </div>
                                    </div>
                                    <div class="list-actions">
                                        <a-button class="btn-dangerous" type="link"
                                            @click.stop="handleDelIconItem(index,item,detailIconGroupList)"
                                            size="small"><delete-outlined /></a-button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex-space-between-center w100">
                                        <a-space @click.stop="handleToggleGroup(item)" style="cursor: pointer">
                                            <up-outlined class="color-fff" v-if="item.show" />
                                            <down-outlined class="color-fff" v-else />
                                            <folder-outlined class="color-fff" />
                                            <span class="color-fff">{{ item.iconName }}</span>
                                        </a-space>
                                        <div class="list-actions">
                                            <a-button class="btn-primary" type="link"
                                            @click.stop="handleOpenGroup(item)"
                                                size="small"><branches-outlined /></a-button>
                                            <a-button class="btn-dangerous" type="link"
                                                @click.stop="handleDelIconItem(index,item,detailIconGroupList)"
                                                size="small"><delete-outlined /></a-button>
                                        </div>
                                    </div>
                                    <div @dragover="handleChildBoxDragOver" class="child-box" v-show="item.show"
                                        >
                                        <div class="sub-item"
                                            :class="{ 'drag-over': dragOverGroup === item && dragItem.value?.dataType === '1' }"
                                            @dragenter="handleDragEnterGroup(item)"
                                            @dragleave="handleDragLeaveGroup"
                                            @dragover="handleSubItemDragOver($event, item)"
                                            @drop="handleDropToGroup(item)">
                                            <template v-for="(subItem, subIndex) in item.childItems">
                                                <div v-if="item.childItems && item.childItems.length > 0"
                                                    @click.stop="handleSet(subItem)"
                                                    :key="subItem.id" class="sub-item-content" draggable="true"
                                                    @dragstart.stop="handleSubDragStart(item, subItem, subIndex)"
                                                    @dragend="handleDragEnd">
                                                    <div class="sub-item-left">
                                                        <img :src="subItem.downloadUrl" alt="sub-item" width="16"
                                                            height="16" />
                                                        <span class="color-fff">{{ subItem.iconName }}</span>
                                                    </div>
                                                    <a-button class="btn-dangerous" type="link" size="small"
                                                        @click.stop="handleDeleteFromGroup(subItem, subIndex,item.childItems)">
                                                        <delete-outlined />
                                                    </a-button>
                                                </div>
                                                <div :key="subItem.id" v-else class="sub-item-empty">
                                                    暂无内容，拖拽图标到此处
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            </div>
                        </template>

                        <div class="sider-bottom flex-space-between-center" v-if="addFolder.visible">
                            <a-space>
                                <up-outlined class="color-fff" v-if="addFolder.show" />
                                <down-outlined class="color-fff" v-else />
                                <folder-outlined class="color-fff" />
                                <a-input class="css-vslrb1" placeholder="新文件夹/图层名称" v-model:value="addFolder.name">
                                    <template #prefix>
                                        <folder-outlined />
                                    </template>
                                </a-input>
                                <check-outlined class="btn-success" @click="handleSubmitFolder" />
                                <close-outlined class="btn-dangerous" @click="handleCloseFolder" />
                            </a-space>
                        </div>
                    </div>
                </div>
            </aside>
            <main class="map-panel">
                <div class="m-s-right-btn">
                    <div class="m-s-zoom">
                        <div class="zoom-add" @click.prevent.stop="zoomInViaNavigation">
                            <PlusOutlined />
                        </div>
                        <div class="zoom-minus" @click.prevent.stop="zoomOutViaNavigation">
                            <MinusOutlined />
                        </div>
                    </div>
                    <a-popover overlayClassName="css-1dowtov" placement="leftBottom" trigger="hover">
                        <div class="m-s-map-icon">
                            <div class="select-btn">
                                <img :src="mapIcon" />
                            </div>
                        </div>
                        <template #title>{{ '' }}</template>
                        <template #content>
                            <div class="map-imglayer-data">
                                <div class="m-i-d-title"> 地图实验室 </div>
                                <div class="select-imglayer">

                                    <div class="img-w" :class="{ active: currentLayer === 0 }"
                                        @click.stop="handleSettingLayer(0, showImgLayer.includes('img_w_label'))">
                                        <div class="img-w-mark">
                                            <a-checkbox-group v-model:value="showImgLayer"
                                                @change="(val: string[]) => handleChangeImgLayer(val, 0)">
                                                <a-checkbox v-for="(dict, index) in layerOptions" :key="dict"
                                                    :value="dict" v-show="index === 0"></a-checkbox>
                                            </a-checkbox-group>
                                            <span> 开启路网 </span>
                                        </div>
                                        <div class="img-w-name">
                                            <span>天地图</span>
                                        </div>
                                    </div>
                                    <div class="img-w" :class="{ active: currentLayer === 1 }"
                                        @click.stop="handleSettingLayer(1, showImgLayer.includes('a_map_img_w_label'))">
                                        <div class="img-w-mark">
                                            <a-checkbox-group v-model:value="showImgLayer"
                                                @change="(val: string[]) => handleChangeImgLayer(val, 1)">
                                                <a-checkbox v-for="(dict, index) in layerOptions" :key="dict"
                                                    :value="dict" v-show="index === 1"></a-checkbox>
                                            </a-checkbox-group>
                                            <span> 开启路网 </span>
                                        </div>
                                        <div class="img-w-name">
                                            <span>高德地图</span>
                                        </div>
                                    </div>
                                    <!-- <div class="img-w" :class="{ active: currentLayer === 2 }" @click.stop="handleSettingLayer(2, showImgLayer.includes('baidu_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,2)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 2"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>百度地图</span>
                  </div>
                </div> -->
                                </div>
                            </div>
                        </template>
                    </a-popover>
                </div>
                <div class="map-viewer" ref="mapViewRef"></div>
            </main>
            <aside class="plan-right-panel">
                <div class="right-header">
                    <div class="plan-icon-title">图标库</div>
                </div>
                <div class="right-content">
                    <a-input class="css-vslrb1 mb10" v-model:value="searchForm.name" placeholder="搜索图标" allow-clear
                        @keydown.enter="handleSearch">
                        <template #suffix>
                            <search-outlined />
                        </template>
                    </a-input>
                    <div class="plan-box flex-space-between-center mb10">
                        <div class="plan-title">模型视图</div>
                        <a-radio-group size="small" class="css-vslrb1" v-model:value="searchForm.iconType"
                            button-style="solid" @change="handleSearch">
                            <a-radio-button value="2d">2D</a-radio-button>
                            <a-radio-button value="3d">3D</a-radio-button>
                        </a-radio-group>
                    </div>
                    <div class="right-scroll">
                        <a-dropdown :trigger="['click']" class="mb10">
                            <div class="ant-dropdown-link" @click.prevent>
                                {{ searchForm.categoryName }}
                                <caret-down-outlined />
                            </div>
                            <template #overlay>
                                <a-menu>
                                    <a-menu-item @click="handleChangeMenu(item)" :key="item.id"
                                        v-for="item in categoryType">
                                        {{ item.name }}
                                    </a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>
                        <a-row type="flex" style="margin-left: -6px; margin-right: -6px; row-gap: 12px">
                            <a-col :span="8" v-for="category in categoryIconList" :key="category.id"
                                style="padding-left: 6px; padding-right: 6px">
                                <div class="card-icon" :class="{ active: category.id === currentIcon.id }"
                                    @click="handleSelection(category)">
                                    <div class="icon-box">
                                        <div class="file-image">
                                            <img :src="category.url" alt="file-image" width="40" height="40" />
                                        </div>
                                        <a-popover :content="category.name">
                                            <div class="icon-label">{{ category.name }}</div>
                                        </a-popover>
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                    </div>
                </div>
            </aside>
        </section>
        <ScenarioPoint
        v-model:visible="showScenarioPoint"
        :viewer="viewMap"
         :row="currentScenarioPoint"
          :mark-list="detailIconGroupList"
           :draw-tool="drawTool"
           @update-current="updateCurrentPoint"
           @update-mark-list="updateMarkList"
           @delete-mark="handleDeleteMark"></ScenarioPoint>
           <ScenarioModel
           v-model:visible="showScenarioModel"
        :viewer="viewMap"
         :row="currentScenarioModel"
          :mark-list="detailIconGroupList"
           :draw-tool="drawTool"
           @update-current="updateCurrentPoint"
           @update-mark-list="updateMarkList"
           @delete-mark="handleDeleteMark"></ScenarioModel>
           <ScenarioPath
           :viewer="viewMap"
           :draw-tool="drawTool"
           @updateCurrent="updateCurrent"
           ref="ScenarioRef"></ScenarioPath>
    </section>
</template>
<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, reactive, ref } from 'vue'
import mapIcon from '/@/assets/images/map-icon.png'
import { useRoute, useRouter } from 'vue-router'
import { currentLayer, handleSettingLayer, initScenarioMapCustom, layerOptions, showImgLayer } from '/@/hooks/Cesium/use-scenario-map'
import {
  sandboxScenarioDetail,
  sandboxScenarioIconList,
  sandboxScenarioUpdate,
  sandboxScenaroIconCategoryList,
} from '/@/api/scenario'
import emitter from '/@/event-bus'
import { useMyStore } from '/@/store'
import DrawScenarioTool from '/@/hooks/Cesium/draw-scenario'
import * as Cesium from 'cesium'
import { message } from 'ant-design-vue'
import ScenarioPoint from '/@/components/scenario-info/point.vue'
import ScenarioModel from '/@/components/scenario-info/model.vue'
import ScenarioPath from '/@/components/scenario-info/path.vue'
import { uuidv4 } from '/@/utils/uuid'
import { decimalToDms } from '/@/utils/coordinate'

const mapViewRef = ref(null)
const store = useMyStore()
let viewMap = null as Cesium.Viewer | null
let drawTool = null as DrawScenarioTool | null
const planDetail = ref({
  name: '',
})

const ScenarioRef = ref()
const showScenarioPoint = ref(false)
const currentScenarioPoint = ref({})
const showScenarioModel = ref(false)
const currentScenarioModel = ref({})
const detailIconGroupList = ref([])
const id = ref('')
const route = useRoute()
const router = useRouter()

const searchForm = reactive({
  categoryId: '',
  categoryName: '',
  name: '',
  iconType: '2d',
})
const page = reactive({
  pageNum: 1,
  pageSize: 1000,
  total: 0,
})

const categoryType = ref([])
const categoryIconList = ref([])
const currentIcon = ref({})
const addFolder = reactive({
  visible: false,
  show: false,
  name: ''
})

// 拖拽相关状态
const dragItem = ref<any>(null)
const dragIndex = ref<number>(-1)
const dragOverGroup = ref<any>(null)

const handleBack = () => {
  router.go(-1)
}

const handleSave = () => {
  const params = JSON.parse(JSON.stringify(planDetail.value))
  params.iconItems = detailIconGroupList.value.map((el) => {
    const params = el
    if (typeof (el.id) === 'string') {
      delete params.id
    }
    if (el.childItems) {
      params.childItems = el.childItems.map(item => {
        const params = item
        if (typeof (item.id) === 'string') {
          delete params.id
        }
        if (item.checked) {
          delete params.checked
        }
        if (item.polyline) {
          delete params.polyline
        }
        return params
      })
    }
    return params
  })

  sandboxScenarioUpdate(params).then(res => {
    if (res.code === 0) {
      message.success('保存成功')
      router.go(-1)
    }
  })
}

const handleOpenGroup = (row) => {
  ScenarioRef.value.initData(row)
}
function handleChangeImgLayer (val:string[], number:number) {
  nextTick(() => {
    handleSettingLayer(number, val.includes(layerOptions[number]))
  })
}

/**
 * 切换分组展开/收起状态
 *
 * @param {Object} item - 分组项
 */
const handleToggleGroup = (item: any) => {
  item.show = !item.show
}

/**
 * 开始拖拽
 *
 * @param {Object} item - 被拖拽的列表项
 * @param {number} index - 被拖拽项的索引
 */
const handleDragStart = (item: any, index: number) => {
  dragItem.value = item
  dragIndex.value = index

  // 设置拖拽图像为空，使用自定义样式
  const dragImage = new Image()
  dragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  dragImage.onload = () => {
    // 这里可以设置拖拽图像，但为了保持简单，使用默认行为
  }
}

/**
 * 拖拽经过主列表项
 *
 * @param {Event} event - Dragover 事件
 * @param {Object} targetItem - 目标列表项
 * @param {number} targetIndex - 目标项的索引
 */
const handleDragOverMain = (event: Event, targetItem: any, targetIndex: number) => {
  event.preventDefault()

  // 从分组内拖出的情况
  if (dragItem.value?._group) {
    // 如果拖到分组上，不允许
    if (targetItem?.dataType === '2') {
      event.dataTransfer!.dropEffect = 'none'
      return
    }
    event.dataTransfer!.dropEffect = 'move'
    return
  }

  // 如果目标是分组且拖拽项是图标，不阻止事件传播，让子元素处理
  if (targetItem?.dataType === '2' && dragItem.value?.dataType === '1') {
    event.dataTransfer!.dropEffect = 'move'
    // 不 return，让事件传播到子元素
  } else if (targetItem?.dataType === '2') {
    // 拖拽的是分组，不允许
    event.dataTransfer!.dropEffect = 'none'
    return
  }

  // 主列表项的排序
  // 分组不能拖到另一个分组上
  if (dragItem.value?.dataType === '2') {
    event.dataTransfer!.dropEffect = 'none'
    return
  }

  if (dragIndex.value === targetIndex) return

  const list = [...detailIconGroupList.value]
  const dragItemData = list[dragIndex.value]

  list.splice(dragIndex.value, 1)
  list.splice(targetIndex, 0, dragItemData)

  detailIconGroupList.value = list
  dragIndex.value = targetIndex
}

/**
 * 拖拽到主列表
 *
 * @param {number} targetIndex - 目标位置索引
 * @description 处理从分组内拖出到主列表的操作
 */
const handleDropToMainList = (targetIndex: number) => {
  if (!dragItem.value?._group && !dragItem.value?._isFromGroup) return

  const groupItem = dragItem.value._group
  const subIndex = dragItem.value._subIndex

  if (!groupItem?.childItems || subIndex === undefined) return

  const item = groupItem.childItems.splice(subIndex, 1)[0]

  if (!item) return

  // 插入到目标位置
  detailIconGroupList.value.splice(targetIndex, 0, { ...item })

  // 在地图上重新添加实体
  if (item.type === '1') {
    try {
      drawTool?.setDataSourcePoint(item.type, item)
    } catch (error) {
      console.error('添加实体失败:', error)
    }
  }

  message.success('已移出分组')
  handleDragEnd()
}

/**
 * 处理主列表项的 drop 事件
 *
 * @param {Event} event - Drop 事件
 * @param {number} targetIndex - 目标位置索引
 * @param {Object} targetItem - 目标列表项
 */
const handleDropToMain = (event: Event, targetIndex: number, targetItem: any) => {
  event.preventDefault()
  console.log('handleDropToMain 触发', dragItem.value, targetItem)

  // 从分组内拖出的情况
  if (dragItem.value?._group || dragItem.value?._isFromGroup) {
    // 不允许拖到分组上
    if (targetItem?.dataType === '2') {
      console.log('不能拖到分组上')
      handleDragEnd()
      return
    }
    event.stopPropagation()
    handleDropToMainList(targetIndex)
    return
  }

  // 如果目标是分组且拖拽项是图标，处理拖入分组
  if (targetItem?.dataType === '2' && dragItem.value?.dataType === '1') {
    console.log('拖入分组处理')
    handleDropToGroup(targetItem)
    return
  }

  // 如果目标是分组，忽略
  if (targetItem?.dataType === '2') {
    return
  }

  event.stopPropagation()
  // 主列表项的排序已在 handleDragOverMain 中完成
  // 这里只需要重置拖拽状态
  handleDragEnd()
}

/**
 * 拖拽结束
 *
 * @description 清空拖拽状态
 */
const handleDragEnd = () => {
  dragItem.value = null
  dragIndex.value = -1
  dragOverGroup.value = null
}

/**
 * 拖拽进入分组区域
 *
 * @param {Object} groupItem - 分组项
 * @description 记录拖拽进入的分组，用于显示视觉反馈
 */
const handleDragEnterGroup = (groupItem: any) => {
  // 如果是从分组内拖出的子项，不能拖回同一个分组
  if (dragItem.value?._group === groupItem) {
    dragOverGroup.value = null
    return
  }

  // 只有主列表中的图标项才能拖入分组
  if (dragItem.value?.dataType === '1' && !dragItem.value._group) {
    dragOverGroup.value = groupItem
  }
}

/**
 * 拖拽到主列表末尾
 *
 * @param {Event} event - Drop 事件
 */
const handleDropToMainEnd = (event: Event) => {
  event.preventDefault()
  console.log('handleDropToMainEnd 触发')

  // 从分组内拖出的情况
  if (dragItem.value?._group || dragItem.value?._isFromGroup) {
    const list = [...detailIconGroupList.value]
    const targetIndex = list.length

    // 从分组中移除
    const groupItem = dragItem.value._group
    const subIndex = dragItem.value._subIndex
    const { _group, _subIndex, ...itemData } = dragItem.value

    groupItem.childItems.splice(subIndex, 1)

    // 添加到主列表末尾
    list.splice(targetIndex, 0, itemData)
    detailIconGroupList.value = list

    console.log('子项拖到列表末尾完成')
    handleDragEnd()
    return
  }

  // 主列表末尾的拖拽已在 handleDragOverMain 中完成
  handleDragEnd()
}

/**
 * 处理 sub-item 的 dragover 事件
 *
 * @param {Event} event - Dragover 事件
 * @param {Object} groupItem - 分组项
 */
const handleSubItemDragOver = (event: Event, groupItem: any) => {
  event.preventDefault()

  // 如果是从分组内拖出的子项，不阻止事件传播
  if (dragItem.value?._isFromGroup && dragItem.value?._group === groupItem) {
    // 允许拖出
    return
  }

  // 主列表图标拖入分组的情况
  if (dragItem.value?.dataType === '1' && !dragItem.value._group) {
    event.dataTransfer!.dropEffect = 'move'
  }
}

/**
 * 拖拽离开分组区域
 *
 * @description 清空拖拽进入的分组状态
 */
const handleDragLeaveGroup = () => {
  dragOverGroup.value = null
}

/**
 * 拖拽经过 child-box 容器
 *
 * @param {Event} event - Dragover 事件
 * @description 阻止事件传播，避免触发父元素的 drop 事件
 */
const handleChildBoxDragOver = (event: Event) => {
  event.preventDefault()
  event.stopPropagation()
}

/**
 * 拖拽放置到分组
 *
 * @param {Object} groupItem - 分组项
 */
const handleDropToGroup = (groupItem: any) => {
  // 如果没有拖拽项，或者是分组自己拖到自己，忽略
  if (!dragItem.value || dragItem.value === groupItem) return

  // 如果是从分组内拖出的子项，忽略（子项拖出由 handleDropToMain 和 handleDropToMainEnd 处理）
  if (dragItem.value._group) return

  // 如果拖拽的是分组，不允许拖入另一个分组
  if (dragItem.value.dataType === '2') {
    message.warning('分组不能拖入其他分组')
    return
  }

  // 从主列表中移除拖拽项
  const mainListIndex = detailIconGroupList.value.findIndex(
    (item) => item === dragItem.value
  )
  if (mainListIndex > -1) {
    detailIconGroupList.value.splice(mainListIndex, 1)
  }

  // 添加到分组的 childItems
  if (!groupItem.childItems) {
    groupItem.childItems = []
  }
  groupItem.childItems.push({
    ...dragItem.value
  })

  // 同时更新地图上的数据
  if (dragItem.value.type === '1') {
    try {
      // drawTool?.removeEntity(dragItem.value.id)
    } catch (error) {
      console.error('移除实体失败:', error)
    }
  }

  console.log('已添加到分组')
  handleDragEnd()
}

/**
 * 开始拖拽分组内的子项
 *
 * @param {Object} groupItem - 分组项
 * @param {Object} subItem - 分组内的子项
 * @param {number} subIndex - 子项索引
 */
const handleSubDragStart = (groupItem: any, subItem: any, subIndex: number) => {
  // 设置拖拽数据，标记为从分组拖出
  dragItem.value = { ...subItem, _group: groupItem, _subIndex: subIndex, _isFromGroup: true }
  dragIndex.value = subIndex
  console.log('开始拖拽子项:', subItem.iconName)
}

/**
 * 删除分组内的子项
 *
 * @param {Object} groupItem - 分组项
 * @param {number} subIndex - 子项索引
 */
const handleDeleteFromGroup = (subItem: any, subIndex: number, children) => {
  if (!subItem) return
  // 从地图上移除
  if (Number(subItem.type) === 1) {
    drawTool?.removeEntity(subItem.id)
  }
  // 从分组中移除
  children.splice(subIndex, 1)
//   message.success('已删除')
}

/**
 * 处理新建分组操作
 *
 * @description 清空分组名称，关闭展开状态，显示新建分组输入框
 */
const handleAddFolder = () => {
  addFolder.name = ''
  addFolder.show = false
  addFolder.visible = true
}

/**
 * 关闭新建分组输入框
 *
 * @description 隐藏新建分组输入框，取消新建分组操作
 */
const handleCloseFolder = () => {
  addFolder.visible = false
}

/**
 * 删除分组/图标
 *
 * @param {number} index - 列表项的索引
 */
const handleDelIconItem = (index: number, item, children) => {
  // 如果是图标，从地图上移除
  if (Number(item.dataType) === 1) {
    drawTool?.removeEntity(item.id)
  } else {
    item.childItems.forEach(item => {
      drawTool?.removeEntity(item.id)
    })
  }
  // 从列表中移除
  children.splice(index, 1)
}

/**
 * 提交新建分组
 *
 * @description 验证分组名称并创建新分组，根据当前图标类型判断维度参数后关闭弹窗
 */
const handleSubmitFolder = () => {
  if (addFolder.name.trim() === '') return message.error('请输入分组名称！')
  setChildren({ name: addFolder.name }, '2', searchForm.iconType === '2d' ? '1' : '2')
  addFolder.visible = false
}

/**
 * 处理图标选择事件
 *
 * @param {Object} item - 选中的图标项
 * @description 更新当前选中的图标，如果点击的是已选中的图标则不做处理
 */
const handleSelection = (item) => {
  if (item.id === currentIcon.value.id) return
  currentIcon.value = item
  drawTool?.setModelHandler(searchForm.iconType)
}

/**
 * 地图放大操作
 *
 * @description 通过导航工具执行地图放大
 */
function zoomInViaNavigation () {
  drawTool?.zoomInViaNavigation()
}

/**
 * 地图缩小操作
 *
 * @description 通过导航工具执行地图缩小
 */
function zoomOutViaNavigation () {
  drawTool?.zoomOutViaNavigation()
}

/**
 * 获取图标列表
 *
 * @param {boolean} [resetPage=true] - 是否重置页码到第一页
 */
const getTypeIconList = async (resetPage = true) => {
  if (resetPage) {
    page.pageNum = 1
  }
  try {
    const res = await sandboxScenarioIconList({
      page: page.pageNum,
      pageSize: page.pageSize,
      param: searchForm,
    })
    categoryIconList.value = res.data.list || []
    page.total = res.data.pagination?.total || 0
    page.pageNum = res.data.pagination?.page || 1
  } catch (error) {
    console.error('获取图标列表失败', error)
  }
}

/**
 * 获取图标分类列表
 *
 * @param {boolean} [fetchIcons=true] - 是否同时获取该分类下的图标列表
 */
const getTypeList = async (fetchIcons = true) => {
  const res = await sandboxScenaroIconCategoryList()
  categoryType.value = res.data || []
  if (fetchIcons && res.data.length > 0) {
    searchForm.categoryId = res.data[0].id
    searchForm.categoryName = res.data[0].name
    getTypeIconList(true)
  }
}

/**
 * 搜索图标
 *
 * @description 根据搜索条件和分类重新获取图标列表
 */
const handleSearch = () => {
  nextTick(() => {
    const row = categoryType.value.find(
      (item) => item.id === searchForm.categoryId,
    )
    searchForm.categoryName = row?.name
    getTypeIconList()
  })
}

/**
 * 切换图标分类
 *
 * @param {Object} item - 选中的分类项
 * @description 更新当前选中的分类并重新获取该分类下的图标列表
 */
const handleChangeMenu = (item) => {
  if (searchForm.categoryId === item.id) return
  searchForm.categoryId = item.id
  getTypeIconList(true)
}

/**
 * 获取方案详情
 *
 * @description 根据方案ID获取方案的详细信息
 */
const getDetail = async () => {
  const res = await sandboxScenarioDetail(id.value)
  planDetail.value = res.data
  detailIconGroupList.value = res.data.iconItems || []
  if (detailIconGroupList.value.length > 0) {
    detailIconGroupList.value.forEach(el => {
      el.show = true
      if (Number(el.dataType) === 1) {
        drawTool?.setDataSourcePoint(el.type, el)
      } else {
        if (el.childItems) {
          el.childItems.forEach(e => {
            drawTool?.setDataSourcePoint(e.type, e)
          })
        }
      }
    })
  }
}

/** 更新分组 */
const updateCurrent = (data) => {
  let index = -1
  detailIconGroupList.value.forEach((el, i) => {
    if (el.id === data.id) {
      index = i
    }
  })
  if (index !== -1) {
    detailIconGroupList.value.splice(index, 1, data)
  }
}

const updateCurrentPoint = (data) => {
  if (Object.keys(data).length === 0) {
    if (data.type === '1') {
      currentScenarioPoint.value = {}
    } else {
      currentScenarioModel.value = {}
    }

    return
  }
  if (data.type === '1') {
    currentScenarioPoint.value = data
    drawTool.setDataSourcePoint(data.type, data)
  } else {
    currentScenarioModel.value = data
    drawTool.setDataSourcePoint(data.type, data)
  }
}

const updateMarkList = (data) => {
  detailIconGroupList.value = data
}

const handleDeleteMark = (row) => {
  const index = detailIconGroupList.value.findIndex(el => el.id === row.id)
  if (index === -1) {
    let childIndex = -1
    let parentIndex = -1
    detailIconGroupList.value.forEach((el, i) => {
      const child = el.childItems?.find(el => el.id === row.id)
      if (child) {
        childIndex = i
        parentIndex = index
      }
    })
    if (parentIndex !== -1 && childIndex !== -1) {
      detailIconGroupList.value[parentIndex].childItems.splice(childIndex, 1)
      drawTool?.removeEntity(row.id)
    }
  } else {
    detailIconGroupList.value.splice(index, 1)
    drawTool?.removeEntity(row.id)
  }
}

/** 设置选中 */
const handleSet = (item) => {
  if (Number(item.dataType) === 2) return
  if (Number(item.type) === 1) {
    currentScenarioPoint.value = {
      id: item.id,
      localName: item.iconName,
      coordinateMode: item.coordinateMode || 'decimal',
      dmsLongitude: decimalToDms(item.longitude),
      dmsLatitude: decimalToDms(item.latitude),
      creator: item.creator,
      longitude: item.longitude,
      latitude: item.latitude,
      altitude: item.altitude,
      type: item.type,
      showNameOnMap: item.showNameOnMap,
      rotate: item.rotate,
      speedUnit: item.speedUnit,
      scale: item.scale,
      ignoreOcclusion: item.ignoreOcclusion
    }
    showScenarioPoint.value = true
    showScenarioModel.value = false
  } else {
    currentScenarioModel.value = {
      id: item.id,
      localName: item.iconName,
      coordinateMode: item.coordinateMode || 'decimal',
      dmsLongitude: decimalToDms(item.longitude),
      dmsLatitude: decimalToDms(item.latitude),
      creator: item.creator,
      longitude: item.longitude,
      latitude: item.latitude,
      altitude: item.altitude,
      type: item.type,
      showNameOnMap: item.showNameOnMap,
      rotate: item.rotate,
      speedUnit: item.speedUnit,
      scale: item.scale,
      ignoreOcclusion: item.ignoreOcclusion
    }
    showScenarioPoint.value = false
    showScenarioModel.value = true
  }
  drawTool?.setDataSourcePoint(item.type, item)
}

/**
 * 设置图标数据到场景和列表
 *
 * @param {Object} data - 图标数据，包含位置等信息
 * @param {string} dataType - 数据类型，'1'表示图标，'2'表示分组
 * @param {string} type - 维度类型，'1'表示2D，'2'表示3D
 * @description 根据当前选中的图标和位置信息，构造图标数据并添加到场景和列表中
 */
const setChildren = (data, dataType, type) => {
  if (Number(dataType) === 1) {
    if (currentIcon.value.id) {
      console.log(data)

      const saveData = {
        altitude: data.position[2],
        dataType: dataType,
        downloadUrl: currentIcon.value.url,
        heading: 0,
        iconId: currentIcon.value.id,
        iconName: currentIcon.value.name,
        ignoreOcclusion: true,
        latitude: data.position[1],
        longitude: data.position[0],
        path: currentIcon.value.objectKey,
        rotate: 0,
        scale: 1,
        showNameOnMap: planDetail.value.showStatus,
        speed: 60,
        speedUnit: 'km/h',
        sportPath: { path: [] },
        type: type,
        childItems: null,
        id: uuidv4()
      }
      detailIconGroupList.value.push(saveData)
      currentIcon.value = {}
      drawTool?.handleClearClickHandler()
      handleSet(saveData)
    }
  } else {
    const saveData = {
      altitude: null,
      dataType: dataType,
      downloadUrl: null,
      heading: null,
      iconId: null,
      iconName: data.name,
      ignoreOcclusion: true,
      latitude: null,
      longitude: null,
      path: null,
      rotate: null,
      scale: null,
      show: true,
      showNameOnMap: planDetail.value.showStatus,
      speedUnit: 'km/h',
      sportPath: { path: [] },
      type: null,
      loopMove: true,
      childItems: [],
      id: uuidv4()
    }
    detailIconGroupList.value.push(saveData)
  }
}

onMounted(() => {
  const obj = initScenarioMapCustom(mapViewRef.value, store)
  viewMap = obj.viewer
  drawTool = obj.drawTool
  emitter.on('scenarioMarkInfo', (info) => {
    if (info.error) {
      console.error('点数据序列化失败:', info.error)
    } else {
      setChildren(info, '1', searchForm.iconType === '2d' ? '1' : '2')
    }
  })
  getTypeList()
  id.value = route.query.id as string
  getDetail()
})

onUnmounted(() => {
  emitter.off('scenarioMarkInfo')
})
</script>
<style lang="scss" scoped>
$border-color: #424242;
$active-color: #297acf;

.plan-container {
    display: flex;
    flex-direction: column;
    height: 100vh;

    .plan-top-panel {
        height: 64px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        border-bottom: 1px solid #303030;
        background-color: #141414;

        .header-left {
            flex: 1;
            display: flex;
            align-items: center;

            .name {
                height: 32px;
                line-height: 32px;
                padding: 0 10px;
                background: rgba(255, 255, 255, 0.08);
                border-radius: 4px;
            }
        }

        .header-right {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            align-items: center;
            background-color: #141414;
        }
    }

    .plan-content {
        height: calc(100% - 64px);
        width: 100%;
        display: flex;

        .plan-left-panel {
            display: flex;
            flex-direction: column;
            height: calc(100vh - 64px);
            overflow: hidden;
            box-sizing: border-box;
            background-color: #141414;
            flex: 0 0 324px;
            max-width: 324px;
            min-width: 324px;
            width: 324px;

            .plan-aside-childern {
                display: flex;
                flex-direction: column;
                height: 100%;
                margin-top: -0.1px;
                padding-top: 0.1px;

                .plan-aside-top {
                    padding: 12px 16px;
                    border-bottom: 1px solid var(--colorBorderSecondary);
                    color: #fff;
                }

                .plan-aside-content {
                    flex: 1;
                    overflow: auto;

                    .empty-box {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                    }

                    .sider-bottom {
                        padding: 12px 16px;
                        background-color: rgba(255, 255, 255, 0.08);
                    }

                    .list-item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 16px;
                        line-height: 60px;
                        cursor: grab;
                        border-bottom: 1px solid var(--colorBorderSecondary);
                        transition: all 0.2s;
                        user-select: none;

                        &:hover {
                            background-color: var(--colorFillTertiary);
                        }

                        &.dragging {
                            opacity: 0.5;
                            cursor: grabbing;
                            background-color: rgba(41, 122, 207, 0.1);
                            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
                        }

                        &[draggable="true"]:active {
                            cursor: grabbing;
                        }

                        &[draggable="true"] {
                            &:hover {
                                border-left: 3px solid #297acf;
                                padding-left: 13px;
                            }
                        }

                        .child-box {
                            overflow: hidden;
                            background-color: rgba(0, 0, 0, 0.3);

                            .sub-item {
                                min-height: 60px;
                                padding: 8px;
                                border: 2px dashed var(--colorBorderSecondary);
                                background-color: #000;
                                border-radius: 4px;
                                transition: all 0.2s;

                                &.drag-over {
                                    border-color: #297acf;
                                    background-color: rgba(41, 122, 207, 0.15);
                                    border-style: solid;
                                }

                                .sub-item-empty {
                                    min-height: 44px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    color: rgba(255, 255, 255, 0.45);
                                    font-size: 12px;
                                }

                                .sub-item-content {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    padding: 8px 12px;
                                    margin-bottom: 8px;
                                    background-color: rgba(255, 255, 255, 0.08);
                                    border-radius: 4px;
                                    cursor: grab;
                                    transition: all 0.2s;

                                    &:last-child {
                                        margin-bottom: 0;
                                    }

                                    &:hover {
                                        background-color: rgba(255, 255, 255, 0.12);
                                        transform: translateX(2px);
                                    }

                                    &:active {
                                        cursor: grabbing;
                                    }

                                    .sub-item-left {
                                        display: flex;
                                        align-items: center;
                                        gap: 8px;
                                        flex: 1;

                                        img {
                                            object-fit: contain;
                                        }
                                    }
                                }
                            }
                        }

                        .list-left {
                            display: flex;
                            gap: 8px;
                            align-items: center;
                            cursor: pointer;
                        }

                        .list-meta {
                            display: flex;
                            flex-direction: column;
                            line-height: 1;

                            .list-title {
                                font-weight: 600;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .map-panel {
            flex: 1;
            height: calc(100vh - 64px);
            background: #e9eef3;
            position: relative;
            overflow: hidden;

            .m-s-right-btn {
                position: absolute;
                right: 20px;
                bottom: 50px;
                z-index: 400;

                .m-s-icon {
                    width: 28px;
                    height: 28px;
                    margin: 10px auto;
                    border-radius: 2px;
                    text-align: center;
                    line-height: 30px;
                    cursor: pointer;
                    position: relative;
                    background-color: #1f1f1f;
                    color: rgba(255, 255, 255, 0.85);

                    &:hover {
                        color: #1088f2;
                    }
                }

                .m-s-zoom {
                    width: 28px;
                    margin: 10px auto;
                    text-align: center;
                    line-height: 28px;
                    box-shadow: 0 0 4px #0009;
                    cursor: pointer;

                    .zoom-add {
                        width: 28px;
                        height: 28px;
                        border-radius: 2px 2px 0 0;
                        background-color: #1f1f1f;
                        color: rgba(255, 255, 255, 0.85);

                        &:hover {
                            color: #1088f2;
                        }
                    }

                    .zoom-minus {
                        width: 28px;
                        height: 28px;
                        border-radius: 0 0 2px 2px;
                        background-color: #1f1f1f;
                        color: rgba(255, 255, 255, 0.85);

                        &:hover {
                            color: #1088f2;
                        }
                    }
                }

                .m-s-map-icon {
                    width: 40px;
                    height: 40px;
                    background: #fff;
                    border-radius: 50%;
                    margin: 10px auto;
                    padding: 3px 0 0;
                    cursor: pointer;

                    .select-btn {
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        margin: 0 auto;
                        -webkit-user-select: none;
                        user-select: none;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%
                        }
                    }
                }
            }

            .map-viewer {
                width: 100%;
                height: 100%;
                position: relative;
            }
        }

        .plan-right-panel {
            background-color: #141414;
            width: 324px;
            box-sizing: border-box;
            height: calc(100vh - 64px);
            display: flex;
            flex-direction: column;

            .right-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 16px;
                border-bottom: 1px solid var(--colorBorderSecondary);

                .plan-icon-title {
                    color: #fff;
                }
            }

            .right-content {
                padding: 8px;
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;

                .plan-box {
                    background: rgba(255, 255, 255, 0.04);
                    border-radius: 4px;
                    padding: 14px 8px;

                    .plan-title {
                        color: #fff;
                    }
                }

                .right-scroll {
                    overflow: auto;
                    flex: 1;
                    max-height: calc(100vh - 64px - 56px);
                    border-radius: 4px;
                    padding: 10px 8px;
                    background: rgba(255, 255, 255, 0.04);

                    .card-icon {
                        box-sizing: border-box;
                        margin: 0;
                        padding: 0;
                        color: rgba(255, 255, 255, 0.85);
                        font-size: 14px;
                        line-height: 1.5714285714285714;
                        list-style: none;
                        font-family:
                            -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
                            "Helvetica Neue", Arial, "Noto Sans", sans-serif,
                            "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
                            "Noto Color Emoji";
                        position: relative;
                        background: #141414;
                        border-radius: 2px;
                        cursor: pointer;
                        transition:
                            box-shadow 0.2s,
                            border-color 0.2s;
                        border: 1px solid #303030;

                        &:hover {
                            border-color: transparent;
                        }

                        &.active {
                            border-color: $active-color;
                        }
                    }

                    .icon-box {
                        width: 100%;
                        height: 90px;
                        padding: 8px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        border-radius: 6px;
                        -webkit-user-select: none;
                        user-select: none;

                    }
                }
            }
        }
    }
}

.file-image {
    display: inline-block;
    width: auto;
    height: auto;

    img {
        display: block;
        max-width: 100%;
        max-height: 100%;
    }
}

.color-fff {
    color: #fff;
}

.ant-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.btn-dangerous {
    color: #dc4446;
}

.btn-success {
    color: #49aa19;
}

.btn-primary {
    color: #1890ff;
}
</style>
